import { IconButton } from "@mui/material";
import React, { useCallback, useState } from "react";
import { FormControl } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close"
import { debounce } from "../../../_metronic/_helpers/debounce";
import { useFormContext } from "react-hook-form";


export default function GlobalFormControl(props) {
  const { formState, getValues } = useFormContext()
  const [lastSubmitCount, setLastSubmitCount] = useState(formState.submitCount)

  const reset = useCallback(
    debounce(() => {
      if (!!getValues("globalSearch") && lastSubmitCount != formState.submitCount) {
        props.onChange({ target: { value: "" } })
        setLastSubmitCount(formState.submitCount)
        document.getElementById("submitButton").click();
      }
      else
        props.onChange({ target: { value: "" } })

    }, 250)
    , [props, formState.submitCount])
  return (
    <div className="d-flex flex-grow-1 position-relative">
      <FormControl
        onKeyUp={(event) => { if (event.key == "Escape") reset() }}
        type="search"
        {...props}
      />
      {props.value &&
        <IconButton
          sx={{
            position: "absolute",
            left: "0",
            top: 5
          }}
          size="small"
          onClick={(e) => {
            props.onChange({ target: { value: "" } })
            document.getElementById("submitButton").click();
          }}>
          <CloseIcon fontSize="small" />
        </IconButton>}
    </div>
  );
}
